import React from "react";
import { CreateSpecificationInformationContainer } from "../../../containers";

const CreateSpecificationInformation = (props) => {
  return <CreateSpecificationInformationContainer />;
};

export default CreateSpecificationInformation;
